import { render } from "./ErrorIcon.vue?vue&type=template&id=4bb0a255"
const script = {}

import "./ErrorIcon.vue?vue&type=style&index=0&id=4bb0a255&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__